import { METHODS, ENDPOINTS } from 'shared/constants';
import { httpClientAuthorized } from '../httpClient';
import {
  UpdateCurrentUserWalletBody,
  UpdateCurrentUserPromoRefLinkBody,
  UpdateUserResponse,
  UpdateUserBody,
} from 'shared/types/api';

export const updateCurrentUserWallet = async (data: UpdateCurrentUserWalletBody) => {
  return await httpClientAuthorized<UpdateUserResponse>({
    method: METHODS.PUT,
    url: ENDPOINTS.UPDATE_USER_WALLET,
    data,
  });
};

export const updateCurrentUserPromoRefLink = async (data: UpdateCurrentUserPromoRefLinkBody) => {
  return await httpClientAuthorized<UpdateUserResponse>({
    method: METHODS.PUT,
    url: ENDPOINTS.UPDATE_USER_PROMO_REF_LINK,
    data,
  });
};

export const selectSkin = async (data: { skin_type: 'skin_hero' | 'skin_oven'; level: number }) => {
  return await httpClientAuthorized<UpdateUserResponse>({
    method: METHODS.POST,
    url: ENDPOINTS.SELECT_SKIN,
    data: {
      skin_type: data.skin_type,
      level: data.level,
    },
  });
};
